<template>
  <formulate-adapter :view-only="viewOnly" :debug="debug" ref="adapter" v-model="formdata" :form-definition="formDefinition"/>
</template>

<script>

import FormulateAdapter from './adapters/Formulate/FormulateAdapter.vue'

export default {

  components: {
    FormulateAdapter
  },

  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    formDefinition: {
      type: Object,
      default: () => ({})
    },
    debug: {
      type: Boolean,
      default: false
    },
    viewOnly: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    formdata: {}
  }),

  mounted() {
    this.formdata = this.value
    this.$emit('mounted', this)
  },

  methods: {
    formRef() {
      return this._.get(this, '$refs.adapter.$refs.form')
    },
    validate() {
      if (this.formRef()) {
        // Vue Formulate Specific
        this.formRef().showErrors()
      }
    },
    /** Aguarda validação assíncrona (regras rodam em Promise); usar antes de hasErrors no submit */
    async validateAsync() {
      const form = this.formRef()
      if (!form) return
      form.showErrors()
      if (typeof form.hasValidationErrors === 'function') {
        await form.hasValidationErrors()
      }
    },
    scrollToFirstInvalidField() {
      const adapter = this.$refs.adapter
      if (adapter && typeof adapter.scrollToFirstInvalidField === 'function') {
        this.$nextTick(() => adapter.scrollToFirstInvalidField())
      }
    },
    hasErrors() {
      if (this.formRef()) {
        return this.formRef().hasErrors
      } else return false
    },
    getErrors(){
      //TODO não está pegando os erros corretamente
      const errors = {};

      if (this.formRef()) {
        // Acessa cada campo dentro do formulário
        const fields = this.formRef().$children;
        fields.forEach(field => {
          // Verifica se o campo possui um array `errors` e se há mensagens de erro
          if (field.formContext && field.formContext.errors && field.formContext.errors.length > 0) {
            errors[field.formContext.name || 'Campo desconhecido'] = field.formContext.errors;
          }
        });
      }

      return errors;
    }
  },

  watch: {
    value(val) {
      this.formdata = val
    },
    formdata(val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style>

</style>
